define('shared/initializer/form/submissions/OffSiteAdyen',[
    './Base',
    '../constants',
    'shared/lib/ctor',
    'shared/lib/RSVP',
    'shared/lib/Emitter',
    'shared/util/hub'
], function(
    Base, 
    constants,
    ctor,
    RSVP,
    Emitter,
    hub
) {
    'use strict';

    function hookEvents() {
        var me = this;
        var adapter = me.adapter;
        adapter.on('payment.start', function(){
            return RSVP.resolve()
            .then(function(){
                return RSVP.resolve()
                    .then(function() {
                        adapter.doBeforeValidation();
                    })
                    .then(function(){
                        return adapter.doBeforeSubmit();        
                    })
                    .then(function(){
                        return adapter.doSubmit();
                    })
                    .then(null, function(reason){
                        me.trigger('submit.fail');
                        me.errors.show(reason);
                        return adapter
                            .doSubmitFail(reason)
                            .then(function(){
                                return RSVP.reject(reason);
                            });
                    });
            })
            .then(function(data){
                me.trigger('submit.success');
                return adapter.doAfterSubmit(data);
            });
        });
    }

    function init() {
        var me = this;
        var adapter = me.adapter;
        var promisePageLoad;
        return RSVP.resolve()
        .then(function(){
            hookEvents.call(me);

            promisePageLoad = adapter.doPageLoad();

            return promisePageLoad
                .then(null,function(reason){
                    me.errors.show(reason);
                    hub.set(constants.SUBMISSION.HUB_LOAD_FINISHED, true);
                    return RSVP.reject(reason);
                });
        })
        .then(function(){

            return adapter.doAfterPageLoad()
                .then(function(){
                    hub.set(constants.SUBMISSION.HUB_LOAD_FINISHED, true);
                },function(reason){
                    me.errors.show(reason);
                    hub.set(constants.SUBMISSION.HUB_LOAD_FINISHED, true);
                    return RSVP.reject(reason);
                });
        });
    }

    var Ctor = ctor(function(){
        var me = this;
        me.base.apply(me, arguments);
        me.errors.on('show', function(error){
            if (!error.fatal && !error.redirect) {
                if (typeof me.adapter.doError === 'function') {
                    me.adapter.doError();
                }
            }
        });
        new Emitter(me);

    }).inherit(Base);

    Ctor.prototype.init = function() {
        var me = this;

        return Base.prototype.init.apply(me, arguments)
            .then(function(){
                me.$form.data('submission-controller', me);
            })
            .then(function(){
                return init.call(me);
            });
    };

    return Ctor;
});
